// common types
export * from '@services/call-api-axios';
export * from './common';
export * from './callApi';
export * from './user';
export * from './userCurrent';
import { paths } from './swagger';

export type Paths = paths;
